import type { Whitelist } from '../types';
import { apiClient } from './client';

export const whitelistApi = {
  getWhitelist: async (guildId: string): Promise<Whitelist> => {
    const response = await apiClient.get<Whitelist>(`/guilds/${guildId}/whitelist`);
    return response.data;
  },

  addWhitelistEntry: async (
    guildId: string,
    type: 'channels' | 'roles' | 'users',
    id: string
  ): Promise<void> => {
    await apiClient.post(`/guilds/${guildId}/whitelist/${type}`, { id });
  },

  removeWhitelistEntry: async (
    guildId: string,
    type: 'channels' | 'roles' | 'users',
    id: string
  ): Promise<void> => {
    await apiClient.delete(`/guilds/${guildId}/whitelist/${type}/${id}`);
  },
};
